var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 0H24V24H0V0Z",
  fill: "#C4C4C4"
});
var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_184_556)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.34315 20.8285L4.8784 18.7794C5.17841 17.6308 5.87728 16.6265 6.84999 15.946L9.21401 14.2922M19.6569 20.8285L19.1216 18.7794C18.8216 17.6308 18.1227 16.6265 17.15 15.946L14.786 14.2922",
  stroke: "#18372A",
  strokeWidth: 2,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("rect", {
  x: 6,
  y: 3,
  width: 12,
  height: 12,
  rx: 6,
  stroke: "#18372A",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.5 15H14.5L13 17L14 20L12 21.5L10 20L11 17L9.5 15Z",
  fill: "#18372A"
}));
function SvgChief(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_184_556",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _ref2), _ref3);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChief);
export default __webpack_public_path__ + "static/media/chief.ada27263ddd3253615fbd1ea8b294486.svg";
export { ForwardRef as ReactComponent };